export function addLeadingZero(number) {
  return String(number).padStart(2, '0');
}

export function createData(key, name, calories, fat, carbs, protein, cost, last) {
  return {
    key,
    name,
    calories,
    fat,
    carbs,
    protein,
    cost,
    last,
  };
}

export const hasError = (columnError, rowIndex) => {
  return columnError && rowIndex <= 1;
};

export const hasErrorIcon = (columnError, rowIndex) => {
  return columnError && rowIndex === 1;
};

export function validateFuelUsage(dataMileage, fuelStart) {
  // Флаги ошибок для каждой недели

  let totalRefueled = 0;
  let totalUsed = 0;

  for (let i = 0; i < dataMileage.length; i += 1) {
    // Значения за текущую неделю
    const refueled = Number(dataMileage[i].refuel);
    const used = Number(dataMileage[i].fuelCharge);

    totalRefueled += refueled;
    totalUsed += used;

    const fuelAvailable = Number(fuelStart) + totalRefueled;

    if (totalUsed - fuelAvailable > 0.001) {
      // Возвращаем массив ошибок и доступное топливо до перерасхода
      return { errorWeek: i + 1, fuelAvailable: Math.round((fuelAvailable - (totalUsed - used)) * 1000) / 1000 };
    }
  }

  return { errorWeek: 0, fuelAvailable: 0 }; // ошибок нет
}
